import React from 'react';
import { useEffect, useState } from 'react';
import { getSolutionTab, buildSolutionTabs } from './helper';
import { getImageAsBase64 } from '../../helpers/fetchDatafromContentSVC';
import { SVBTypography, SVBTabs, SVBCard } from '@svb/svb-react-components';
import SolutionTabBlock from './SolutionTabBlock';
import { slugCreator } from '../../core/useStore';
import Loading from '@svb/api-loading-component/dist/components/index';

const SolutionTabs = (props) => {
  const [activeIndex, setActiveIndex] = useState('');
  const solutionsContent = props.content;
  const catalog =
    solutionsContent && 'catalog' in solutionsContent ? solutionsContent.catalog : 'Sol1';
  const items = buildSolutionTabs(catalog);
  const actItem = props.activeItem;
  const itemsList = items[0];
  const labelList = items[1];
  const keyList = items[2];
  useEffect(() => {
    setActiveIndex(keyList[actItem]);
  }, []);
  const SolutionTab = () => {
    const [loading, setloading] = useState(true);
    const [imgData, setimgData] = useState('');
    const contentKey = activeIndex ? itemsList[activeIndex] : 'no-tabs';
    const tabContent = getSolutionTab(props.solutionsURL, contentKey);
    const tabData = tabContent ? tabContent.response : ['No Tab Data'];
    const img = tabData?.image || '';
    const imgURL = `${props?.solutionsURL}?resourcePath=solutions/${contentKey}/resources&resourceName=${img}`;
    const header = tabData?.header || 'Loading Solution';
    const description = tabData?.description || 'Desc';
    const cards = tabData?.cards || 'Desc';
    // get img-data only if img exists
    if (img) {
      const imgdata = getImageAsBase64(imgURL);
      imgdata.then((result) => {
        setimgData(result);
      });
    }
    useEffect(() => {
      setloading(false);
      if (activeIndex === undefined && tabContent === 'No Content') {
        props?.isErrorPath();
      }
    }, [contentKey, tabContent]);

    const learnMoreLabel = () => (
      <span className='learn-more-label'>
        {'Learn More'}
        <i className='fa-solid fa-arrow-right right-arrow-icon' />
      </span>
    );

    return header === 'Loading Solution' || loading ? (
      <>
        <div className='solutions-loading'>
          <Loading />
        </div>
      </>
    ) : (
      <>
        <div className='svb-container-fixed col-md-9 col-sm-12 mt-5 container'>
          <SolutionTabBlock
            type='bodyBlock'
            title={header}
            description={description}
            bgColor='secondary'
            image={imgData}
          />
          <div className='mt-10'>
            <SVBTypography type='heading-large'>{header} Use Cases</SVBTypography>
            <div className='blue-line'></div>
            <div className='content mt-6 mb-10'>
              {Array.isArray(cards) ? (
                cards.map((card, i) => (
                  <div key={i}>
                    <SVBCard
                      cardIcon={card.icon}
                      link={`/solutions/${contentKey}/${card.content}`}
                      title={card.name}
                      description={card.description}
                      buttonLabel={learnMoreLabel()}
                      extraClasses=' solution-catalog-card mt-5 p-3'
                      cardOptions={{ cardClickable: false }}
                      explicitImgWidth={170}
                      explicitImgHeight={62}
                      lazyLoading={true}
                      datatestid={{
                        card: slugCreator(card.name),
                        learnMore: slugCreator('card-button' + '-' + 'Learn More'),
                      }}
                    ></SVBCard>
                  </div>
                ))
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <div className='solutions-tabs' data-testid='solution-tabs'>
        <SVBTabs
          onPress={setActiveIndex}
          preset={'tabFull'}
          items={labelList}
          activeItem={activeIndex}
        />
      </div>
      {activeIndex ? (
        <SolutionTab content={activeIndex} />
      ) : (
        <>
          {' '}
          <SolutionTab data-testid='placeholder' content={actItem} />{' '}
        </>
      )}
    </>
  );
};

export default SolutionTabs;
